import { useRecoilState } from "recoil";
import { userState } from "../recoil/atom";
import useAlert from "./useAlert";

function useUser() {
  const [user, setUser] = useRecoilState(userState);
  const { accessAuthAlert, editAuthAlert } = useAlert();

  const isDisabledWithoutAllbranch = () => {
    if (!user) return false;
    if (user.level === "5") return false;
    // Phase 6c: 정규화 테이블 기반 — manageradmin 스코프의 is_all 만 체크
    if (user.permissions?.manageradmin?.is_all === true) return false;
    // Phase 7-3: 다중 지점 권한자도 dropdown 활성화 (광교+인천 등 좁히기 가능).
    // dropdown 옵션 자체가 filterBranchListByPermissions 로 본인 권한 지점만 노출되므로
    // disabled 처리는 단일 권한자(선택지 없음) 에만 의미 있음.
    const branches = user.permissions?.manageradmin?.branches || [];
    if (branches.length > 1) return false;
    return true;
  };

  const isAuthorizationByLevel = (level, mode) => {
    if (!user) return false;
    if (parseInt(user?.level) < level) {
      mode === "access" && accessAuthAlert();
      mode === "edit" && editAuthAlert();
      return false;
    }
    return true;
  };

  return { user, setUser, isDisabledWithoutAllbranch, isAuthorizationByLevel };
}

export default useUser;
